import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  RolloverPropertyTransferredNonShareConsiderationOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred-non-share-consideration.options';
import { RolloverFormFactory } from '../rollover-form/rollover-form.factory';
import {
  RolloverPropertyTransferredOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred.options';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  RolloverAddNonShareConsiderationTypeModalComponent,
} from '../rollover-add-non-share-consideration-type-modal/rollover-add-non-share-consideration-type-modal.component';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { TranslateService } from '@ngx-translate/core';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';

@Component({
  selector: 'app-rollover-property-non-share-consideration-form',
  templateUrl: './rollover-property-non-share-consideration-form.component.html',
  styleUrls: ['./rollover-property-non-share-consideration-form.component.scss'],
  standalone: false,
})
export class RolloverPropertyNonShareConsiderationFormComponent implements OnInit, OnDestroy {

  onFormChangeSubscription: Subscription;

  @Input()
  propertyForm: AdvancedFormGroup<RolloverPropertyTransferredOptions>;

  @Input()
  form: AdvancedForm<RolloverOptions>;

  @Input()
  propertyTransferredIndex: number;

  nonShareConsiderationsSubscription: Subscription;

  nonShareConsiderationsKeyValues: { key: string, value: string }[] = [];

  constructor(public readonly formService: RolloverFormFactory,
              private readonly translateService: TranslateService,
              public modalService: NgbModal) {

  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get isCalculateMaximumNonShareConsideration(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isCalculateMaximumNonShareConsideration as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get nonShareConsiderations(): AdvancedFormArray<RolloverPropertyTransferredNonShareConsiderationOptions> {
    return this.propertyForm.formElements.nonShareConsiderations as AdvancedFormArray<RolloverPropertyTransferredNonShareConsiderationOptions>;
  }

  get nonShareConsiderationsSelectKeyValues(): { key: string, value: string }[] {
    return this.nonShareConsiderationsKeyValues;
  }

  ngOnInit() {
    this.mapNonShareConsiderations(this.form.formElements.nonShareConsiderations.value);

    this.nonShareConsiderationsSubscription = this.form.formElements.nonShareConsiderations.value$.subscribe(value => {
      this.mapNonShareConsiderations(value.value);
    });
  }

  ngOnDestroy() {
    this.nonShareConsiderationsSubscription.unsubscribe();
  }

  mapNonShareConsiderations(nonShareConsiderations) {
    this.nonShareConsiderationsKeyValues = nonShareConsiderations.map((nonShareConsideration) => {
      return {
        key: nonShareConsideration.title,
        value: nonShareConsideration.id,
      };
    });
  }

  async addNonShareConsiderationType() {
    const modal = this.modalService.open(RolloverAddNonShareConsiderationTypeModalComponent);
    return;
  }

  addPropertyTransferredNonShareConsideration() {
    this.nonShareConsiderations.appendNew();
  }

  getAmountOfNonShareConsideration(propertyTransferredNonShareConsideration: AdvancedFormGroup<RolloverPropertyTransferredNonShareConsiderationOptions>): AdvancedFormControl<number, number, number> {
    return propertyTransferredNonShareConsideration.formElements.amountOfNonShareConsideration as AdvancedFormControl<number, number, number>;
  }

  getNonShareConsiderationId(propertyTransferredNonShareConsideration: AdvancedFormGroup<RolloverPropertyTransferredNonShareConsiderationOptions>): AdvancedFormControl<string, string, string> {
    return propertyTransferredNonShareConsideration.formElements.nonShareConsiderationId as AdvancedFormControl<string, string, string>;
  }

  async removePropertyTransferredNonShareConsideration(propertyTransferred: AdvancedFormGroup<RolloverPropertyTransferredOptions>, propertyTransferredNonShareConsiderationIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent);
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cette contrepartie autre qu\'en actions';
    modal.closed.subscribe(async result => {
      if (result === true) {
        (propertyTransferred.formElements.nonShareConsiderations as AdvancedFormArray<RolloverPropertyTransferredNonShareConsiderationOptions>).delete(propertyTransferredNonShareConsiderationIndexToRemove);
        return;
      }
    });

    return;
  }
}
